import { render } from "./ListaMuzee.vue?vue&type=template&id=05b8b1f1&scoped=true"
import script from "./ListaMuzee.vue?vue&type=script&lang=js"
export * from "./ListaMuzee.vue?vue&type=script&lang=js"

import "./ListaMuzee.vue?vue&type=style&index=0&id=05b8b1f1&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\peles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b8b1f1"]])

export default __exports__